import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {ChargedActModel} from '../../../api/entity/chargedAct.model';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {ChargedActConverter} from '../../../api/entity/converter/chargedAct.converter';

@Injectable({ providedIn: 'root' })
export class ChargedActDataService extends AbstractDataServiceV2<ChargedActModel, ChargedActConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: ChargedActConverter) {
        super('ChargedAct', http, httpUrlGenerator, logger, config, converter);
    }
}
